<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const auth = useAuthStore();
const router = useRouter();

onMounted(async () => {
  auth.logout();
  await router.replace({ name: 'main' });
});
</script>

<template>
  <main class="logout">
    <p>You have logged out.</p>
  </main>
</template>

<style scoped>
.logout {
  max-width: 28rem;
  margin: 6rem auto;
  padding: 1.5rem;
  text-align: center;
  color: #4b5563;
}
</style>
